import { Swatches } from '@phosphor-icons/react';
import { scanPiecePrice, scanTotal, scanPackSize } from '@/lib/scanQuantity';
import { fmt } from '@/lib/api';
import { scanDiscountedTotal } from '@/lib/scanDiscount';
import { ScanMoneyInput } from '@/components/ScanMoneyInput';

export const ScanItemDetails = ({ item, onChange, onVariant, onValidityChange }) => {
  const id = item._key;
  const field = (name, label, type = 'text', extra = {}) => <label className="min-w-0 text-xs text-gray-600">
    {label}<input type={type} value={name === 'eenheid_aantal' ? scanPackSize(item) : (item[name] ?? '')} onChange={e => onChange(name, e.target.value)}
      className="field-input mt-1 w-full text-sm" data-testid={`${name === 'prijs' || name === 'korting' ? name : `scan-${name}`}-${id}`} {...extra} />
  </label>;
  return <div id={`scan-details-${id}`} className="border-t border-gray-100 bg-gray-50/70 px-3 sm:px-4 py-4" data-testid={`item-edit-drawer-${id}`}>
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
      {field('ean', 'Barcode')}
      {field('eenheid', 'Eenheid')}
      {field('eenheid_aantal', 'Stuks per pak', 'number', { min: 1, step: 1 })}
      <label className="min-w-0 text-xs text-gray-600">{item.prijs_per_stuk ? 'Prijs per stuk' : 'Prijs per pak'}
        <ScanMoneyInput value={item.prijs} onChange={v => onChange('prijs', v)} testId={`prijs-${id}`}
          label={item.prijs_per_stuk ? 'Prijs per stuk' : 'Prijs per pak'} className="mt-1"
          validationKey={`detail-price-${id}`} onValidityChange={onValidityChange} />
      </label>
      <label className="text-xs text-gray-600">Prijs ingevoerd per
        <select value={item.prijs_per_stuk ? 'stuk' : 'pack'} onChange={e => onChange('prijs_per_stuk', e.target.value === 'stuk')}
          className="field-input mt-1 text-sm" data-testid={`per-stuk-${id}`}><option value="stuk">Stuk</option><option value="pack">Pak</option></select>
      </label>
      {field('btw', 'Btw (%)', 'number', { min: 0, max: 100, step: '0.1' })}
      <label className="text-xs text-gray-600">Bedrag excl. btw
        <ScanMoneyInput value={scanDiscountedTotal(item, scanTotal(item) * scanPiecePrice(item))}
          onChange={v => onChange('lijn_totaal', v)} testId={`scan-amount-edit-${id}`} label="Bedrag excl. btw" className="mt-1"
          negative={scanTotal(item) < 0} validationKey={`amount-${id}`} onValidityChange={onValidityChange} />
      </label>
      <div className="text-xs text-gray-600">
        <span className="block mb-1">Variant</span>
        <button type="button" onClick={onVariant} className="btn btn-secondary btn-sm gap-2 max-w-full" data-testid={`variant-pick-${id}`}>
          <Swatches size={16} /> <span className="whitespace-normal break-words">{item.variant_label || 'Kiezen / wijzigen'}</span>
        </button>
      </div>
      <div className="text-xs text-gray-500 leading-6" data-testid={`scan-stock-detail-${id}`}>
        Voorraad: {item.voorraad ?? '—'}<br />{fmt(scanPiecePrice(item))} / stuk
      </div>
    </div>
  </div>;
};